import BookChapters from "../components/BookChapters";

export default function BookChaptersPage() {
  return (
    <section className="py-10">
      <BookChapters />
    </section>
  );
}
